import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { MapRequest, MapResponse } from '@rma/generic/maps/domain';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MapsService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public queryMapMarkers(request: MapRequest): Observable<MapResponse> {
    const url = this.rmaApiUrl('v1/Map/QueryMapMarkers');
    return this.httpClient.post<MapResponse>(url, { ...request });
  }
}
